import React from 'react';
import classes from './title.module.css';
import Spider from '../../../assets/images/spider.png';
import BirthdaySpider from '../../../assets/images/birthday-spider.png';
import TeamBuildingSpider from '../../../assets/images/team-building-spider.png';
import SummerSpider from '../../../assets/images/summer-spider.png';
import WinterSpider from '../../../assets/images/winter-spider.png';
import FootballSpider from '../../../assets/images/football-spider.png';

const Title = (props) => {
    const spider = props.isBirthday ? BirthdaySpider : props.isTeamBuilding ? 
    TeamBuildingSpider : props.camp === 'summer' ? SummerSpider : props.camp === 'winter' ? 
    WinterSpider : props.camp === 'football' ? FootballSpider : Spider;
    
    return (
        <div className={classes.Title}>
            <img 
                src={spider} 
                alt='spider' 
                className={props.camp === 'football' ? classes.FootballSpider : undefined}
            />
            <h3>{props.title}</h3>
            <img 
                src={spider} 
                alt='spider' 
                className={props.camp === 'football' ? classes.FootballSpider : undefined}
            />
        </div>
    )
}

export default Title;